import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9d90ef6")

_pushScopeId("data-v-b9d90ef6")
const _hoisted_1 = { class: "toc_ui__reminder_main" }
const _hoisted_2 = { class: "toc_ui__reminder_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_4 = {
  key: 0,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("3.")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("天收购保障，须具备268V检测认证承诺书，单独出具此检测评估报告不具备法律效⼒；")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("4.经268V买车无忧检测+质保双认证的车辆，车况即符合268V买车无忧保准入条件，经采购付费，可享有“最低一年3万公里”质保服务（精选保障plus产品可享一年不限公里保修） ，具体保修范围、最高赔付限额、保修期限（年限及公里数限制）等以实际购买产品为准。")
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "3.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_23 = {
  key: 2,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "3.本报告检测内容仅供参考，不可直接作为车辆交易凭证，如您参考此报告购车，268V不承担任何检测失误责任；", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "4.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_31 = {
  key: 3,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", null, "2.除事故检测、泡水检测、火烧检测、发动机、变速箱外，其余检测项目结果仅反映检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "3.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("4.")
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("天收购保障，须具备268V检测认证承诺书，单独出具此检测评估报告不具备法律效⼒；")
const _hoisted_42 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("span", null, "5.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_44 = {
  key: 0,
  class: "toc_ui__anti_body"
}
const _hoisted_45 = { class: "toc_ui__anti_farkurl" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farklogo" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farktext" }, "识别二维码查看报告真伪", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _hoisted_3,
      (((_ctx.state.reportMsg.Rp299() && !_ctx.state.reportMsg.RpJG()) || _ctx.state.reportMsg.RpHC() || _ctx.state.reportMsg.RpSRZ()) && !_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createVNode("span", null, [
              _hoisted_9,
              (_ctx.state.channelType === 'jiaxuan')
                ? (_openBlock(), _createBlock("span", _hoisted_10, "100"))
                : (_openBlock(), _createBlock("span", _hoisted_11, "90")),
              _hoisted_12
            ]),
            _hoisted_13,
            (_ctx.state.reportMsg.RpSRZ())
              ? (_openBlock(), _createBlock("span", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16
                ]))
              : _createCommentVNode("", true),
            _createVNode("span", null, _toDisplayString(_ctx.state.reportMsg.RpSRZ() ? '5' : '4') + ".268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", 1)
          ]))
        : (_ctx.state.reportMsg.RpFJ() && !_ctx.state.reportMsg.RpCK())
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22
            ]))
          : (_ctx.state.reportMsg.RpCK())
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _hoisted_29,
                _hoisted_30
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _createVNode("span", null, [
                  _hoisted_38,
                  (_ctx.state.channelType === 'jiaxuan')
                    ? (_openBlock(), _createBlock("span", _hoisted_39, "100"))
                    : (_openBlock(), _createBlock("span", _hoisted_40, "90")),
                  _hoisted_41
                ]),
                _hoisted_42,
                _hoisted_43
              ]))
    ], 512), [
      [_vShow, _ctx.state.channelType !== 'lingshou']
    ]),
    (_ctx.state.antiFakeUrl && !_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_44, [
          _createVNode("div", _hoisted_45, [
            _createVNode("img", {
              src: _ctx.state.antiFakeUrl
            }, null, 8, ["src"]),
            _hoisted_46
          ]),
          _hoisted_47
        ]))
      : _createCommentVNode("", true)
  ]))
})